import { render } from "./TVmodal.vue?vue&type=template&id=f5f7b3b8"
const script = {}

import exportComponent from "/home/goran/projects/plodine/plodine/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__